var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"17","height":"18","viewBox":"0 0 17 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M17 8.89622H8.90476V0.636475H8.09524V8.89622H0V9.72219H8.09524V17.9819H8.90476V9.72219H17V8.89622Z","fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }